// extracted by mini-css-extract-plugin
export default {"cls1":"SimplePaperPodcast-cls1__e7c9a01be247f670db51","cls2":"SimplePaperPodcast-cls2___ff3ad8521d585786a5e SimplePaperPodcast-cls1__e7c9a01be247f670db51"};